<script>
    import { onMount } from "svelte";
    import Header from "../header.svelte";
    import IFTAInput from "../../utils/iftainput.svelte";
    import { api_host, user_store, subscription_info_store, subscription_store } from "../../stores.js";
    import Modal from '../elements/Modal.svelte';
    import { formatDate, compare_plans, get_next_plan_date, epochToLocal } from '../../utils/format.js';
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from '../../utils/toast_message.js';
    import { init_data } from '../../init.js';
    import Swal from "sweetalert2";


    const { auth_type, auth_token, domain_code } = getToken();

    let is_busy = false;
    let content_title = "Settings - Subscription";
    let plan_title = "";
    let subscription_options = ["Basic (annually)", "Basic (monthly)", "Pro (annually)", "Pro (monthly)", "Prime (annually)", "Prime (monthly)"];
    let subscription_plan = '';
    let original_sub_plan = '';
    let selected_plan_type = '';
    let selected_plan_freq = '';
    let new_plan_extra_price = 0;
    let confirm_modal_show = false;
    let update_subscription_text = '';
    let subscription_info = {};
    let subscription_self = {};
    let myself = {};

    onMount(() => {
        init_data('subscription');
    });

    subscription_info_store.subscribe(value => {
        subscription_info = value;
    });
    subscription_store.subscribe(value => {
        subscription_self = value;
    });

    $: {
        if (subscription_plan) {
            // const current_plan_price = myself.plan_freq === 'year' ? subscription_info[myself.plan_type][0] * 12 : subscription_info[myself.plan_type][1];
            const current_plan_type = original_sub_plan.split(' ')[0].toLowerCase();
            selected_plan_type = subscription_plan.split(' ')[0].toLowerCase();
            selected_plan_freq = subscription_plan.includes('annually') ? 'year' : 'month';
            const year_plan_price = subscription_info[selected_plan_type][0] * 12;
            const month_plan_price = subscription_info[selected_plan_type][1];
            const selected_plan_price = selected_plan_freq === 'year' ? year_plan_price : month_plan_price;
            const formated_plan_price = new Intl.NumberFormat().format(selected_plan_price);
            const formated_new_plan_extra = new Intl.NumberFormat().format(new_plan_extra_price);
            const base_date = new_plan_extra_price > 0 ? new Date() : myself.paid_at;
            const renew_date = new Date(
                (new Date(base_date)).getFullYear() + (selected_plan_freq === 'year' ? 1 : 0),
                (new Date(base_date)).getMonth() + (selected_plan_freq === 'year' ? 0 : 1),
                (new Date(base_date)).getDate()
            );
            const helper_text = compare_plans(current_plan_type, selected_plan_type) === true ? `All ${current_plan_type.toUpperCase()} features are avaialble to you until the next billing cycle.` : '';
            update_subscription_text = `You will be charged <b>$${new_plan_extra_price > 0 ? formated_new_plan_extra : 0}</b>. Your subscription will automatically renew on ${formatDate(renew_date)} for $${formated_plan_price}. Cancel any time at least a day before each renewal date. ${helper_text} <b>Warning: Upgrading or downgrading your plan will result in the loss of existing data.</b>`;
        }
    };

    user_store.subscribe(value => {
        myself = value;
        subscription_plan = myself.plan_type;
        subscription_plan = subscription_plan[0].toUpperCase() + subscription_plan.slice(1);
        if (myself.plan_freq === 'year') {
            subscription_plan += ' (annually)';
        } else {
            subscription_plan += ' (monthly)';
        }
        original_sub_plan = subscription_plan;
        if (original_sub_plan) plan_title = '(' + myself.plan_type.toUpperCase() + ' PLAN)';
    });

    const updateSubscription = async () => {
        is_busy = true;
        const draft_res = await doFetch(
            `${api_host}/api/subscription/draft/sub`,
            'POST',
            { new_plan_type: selected_plan_type, new_plan_freq: selected_plan_freq },
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (draft_res.status) {
            confirm_modal_show = true;
            new_plan_extra_price = draft_res['extra_price'];
        } else {
            toast_message(false, draft_res.msg || 'Something wrong, please try again later', 3000);
        }
        is_busy = false;
    };

    const pauseSubscription = async () => {
        Swal.fire({
            title: myself.subscription.is_paused ? 'Resume Subscription?' : 'Pause Subscription?',
            text: '',
            buttonsStyling: true,
            cancelButtonText: "Cancel",
            showCancelButton: true,
            showConfirmButton: true,
            icon: "success"
        }).then(async (e) => {
            if (e.isConfirmed) {
                is_busy = true;
                if (myself.subscription.is_paused) {
                    const pause_res = await doFetch(
                        `${api_host}/api/subscription/resume/sub`,
                        'POST',
                        {},
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    if (pause_res.status) {
                        toast_message(true, pause_res.msg, 3000);
                        init_data('myself');
                    } else {
                        toast_message(false, pause_res.msg || 'Something wrong, please try again later', 3000);
                    }
                } else {
                    const pause_res = await doFetch(
                        `${api_host}/api/subscription/pause/sub`,
                        'POST',
                        {},
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    if (pause_res.status) {
                        toast_message(true, pause_res.msg, 3000);
                        init_data('myself');
                    } else {
                        toast_message(false, pause_res.msg || 'Something wrong, please try again later', 3000);
                    }
                }
                is_busy = false;
            }
        });
    };

    const cancelSubscription = async () => {
        Swal.fire({
            title: 'Cancel Subscription?',
            text: '',
            buttonsStyling: true,
            cancelButtonText: "Cancel",
            showCancelButton: true,
            showConfirmButton: true,
            icon: "success"
        }).then(async (e) => {
            if (e.isConfirmed) {
                is_busy = true;
                const cancel_res = await doFetch(
                    `${api_host}/api/subscription/cancel/sub`,
                    'POST',
                    {},
                    { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                );
                if (cancel_res.status) {
                    toast_message(true, cancel_res.msg, 3000);
                    // init_data('myself');
                    const res = await doFetch(
                        api_host + '/auth/logout',
                        'POST',
                        {},
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    localStorage.removeItem('HoyToKenTy');
                    localStorage.removeItem('HoyToKenTo');
                    window.location.reload();
                } else {
                    toast_message(false, cancel_res.msg || 'Something wrong, please try again laster', 3000);
                }
                is_busy = false;
            }
        });
    };
</script>


<Header title="{content_title}" bind:is_busy={is_busy} />

<div class="contentholder">
    {#if myself.is_trial}
        <div class="section">
            <div class="noticeholder">
                <b>Subscription change is not available on a free trial account.</b>
            </div>
        </div>
    {:else}
        <!-- <div class="section">
            <div class="noticeholder">
            Below you can change your subscription plan or cancel subscription plan.
            </div>

            <div class="ff rowwrap subscriptionholder">
                <IFTAInput 
                    type="select"
                    label={original_sub_plan === subscription_plan ? "Your Subscription Plan" : "Change Subscription Plan"}
                    select_options={myself.subscription.is_canceled === true ? ['Canceled'] : subscription_options}
                    disabled={myself.subscription.is_canceled}
                    bind:value={subscription_plan}
                />
            </div>
            {#if myself.subscription.is_canceled !== true && subscription_self.current_period_end}
                <p>Next subscription renewal date: {formatDate(epochToLocal(subscription_self.current_period_end))}</p>
            {/if}
        </div> -->

        {#if myself.subscription.is_canceled === true && subscription_self.canceled_at}
            <p>Your subscription was canceled on {formatDate(epochToLocal(subscription_self.canceled_at))}. You will continue to have access to the software until {formatDate(get_next_plan_date(myself.subscription.paid_at, myself.subscription.plan_freq))}.
            </p>
        {:else}
            {#if myself.subscription && myself.subscription.next_plan_type}
                <p>Your subscription plan will be updated to {myself.subscription.next_plan_type.toUpperCase()} on {formatDate(get_next_plan_date(myself.subscription.paid_at, myself.subscription.plan_freq))}</p>
            {/if}
        {/if}

        <div class="buttonholder">
            <!-- <button class={`savebutton ${(original_sub_plan === subscription_plan || is_busy) ? 'disable_btn' : ''}`} on:click={() => {updateSubscription();}} disabled={(original_sub_plan === subscription_plan) || is_busy}>
                <i class="far fa-save"></i> Update Subscription
            </button> -->
            &nbsp;&nbsp;
            <button class={`pausebutton ${(original_sub_plan !== subscription_plan || is_busy || myself.subscription.is_canceled) ? 'disable_btn' : ''}`} on:click={() => {pauseSubscription();}} disabled={(original_sub_plan !== subscription_plan) || is_busy || myself.subscription.is_canceled}>
                <i class="far fa-pause"></i> {myself.subscription.is_paused ? 'Resume Subscription' : 'Pause Subscription'}
            </button>
            &nbsp;&nbsp;
            <button class={`cancelbutton ${(original_sub_plan !== subscription_plan || is_busy || myself.subscription.is_canceled) ? 'disable_btn' : ''}`} on:click={() => {cancelSubscription();}} disabled={(original_sub_plan !== subscription_plan) || is_busy || myself.subscription.is_canceled}><i class="far fa-window-close"></i> Cancel Subscription</button>
        </div>
        <div style="padding: 10px; padding-top: 40px;">
            <h5>Pause Subscription:</h5>
            <p>When you choose to pause your subscription, your website will become inactive. You can still log in to the House of Yards App software but won't be able to create new jobs or quotes within the app.</p>
            <h5>Cancel Subscription:</h5>
            <p>If you decide to cancel your subscription, you won't be able to log in to your account. Your website domain contents will be erased, and the domain will become available for others to choose. All your data associated with the account will be permanently erased. Please note that canceling your subscription will result in the permanent deletion of your data.</p>
        </div>
    {/if}
</div>

<Modal bind:modal_show={confirm_modal_show} modal_width={window.innerWidth < 600 ? window.innerWidth - 10 : 600}>
    <p style='margin-top: 15px;'><i>{@html update_subscription_text}</i></p>
    <div class='buttons'>
        <button class='confirm_btn' on:click={() => { confirm_modal_show = false; }}>
            CANCEL
        </button>
        <button class='confirm_btn confirm_subsription' on:click={async () => {
            is_busy = true;
            confirm_modal_show = false;
            const update_res = await doFetch(
                `${api_host}/api/subscription/update/sub`,
                'POST',
                { plan_type: selected_plan_type, plan_freq: selected_plan_freq },
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (update_res.status) {
                toast_message(true, update_res.msg, 2000);
                init_data('myself');
            } else {
                toast_message(false, update_res.msg || 'Something wrong, please try again later', 3000);
            }
            is_busy = false;
        }}>
            UPDATE
        </button>
    </div>
    <span class='agree_tos'>By continuing, you agree to our <a href='https://houseofyards.tawk.help/article/privacy' style='color: black;' target='_blank'><b>Privacy Policy</b></a> and <a href='https://houseofyards.tawk.help/article/terms-of-service' style='color: black;' target='_blank'><b>Terms of Service</b></a></span>
</Modal>


<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    .contentholder {
        padding: 0px;
        width: 100%;
    }
    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        /* justify-content: space-between; */
    }
    .buttonholder button {
        max-width: 300px;
    }
    .buttonholder button.savebutton {
        color: white;
        background-color: #357a38;
    }
    .buttonholder button.pausebutton {
        color: white;
        background-color: #ff9100;
    }
    .buttonholder  button.cancelbutton {
        color: white;
        background-color: #ab003c;

    }
    :global(.subscriptionholder .group) {
        max-width: 300px;
    }
    .subscriptionholder {
        align-items: center;
    }
    .disable_btn {
        opacity: 0.8;
        cursor: not-allowed;
    }
    .agree_tos {
        display: block;
        margin-top: 15px;
        text-align: right;
        font-size: 12px;
    }
    .buttons {
        text-align: right;
    }
    .noticeholder {
        width: 100%;
        margin-top: 25px;
        font-size: 1rem;
        font-style: italic;
        color: #666;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 0px;
            width: 100%;
        }
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
            margin-right: 0px;
        }
    }
</style>